<template>
  <el-dialog :close-on-click-modal="false" :visible="safetyEditFormVisible" :modal-append-to-body='false' :before-close="closeSafetyEditForm">
    <el-tabs v-model="viewName">
      <el-tab-pane label="安全管理" name="editForm">
        <el-form :model="safetyEditForm" ref="editForm" size="mini" class="detail_form">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="场站信息" name="stationInformation">
              <el-col :span="12">
                <el-form-item label="运营商名称：" :label-width="formLabelWidth" prop="operatorId">
                  <el-cascader  size="mini" clearable ref="cascader"
                                placeholder="运营商"  filterable
                                :options="operatorForSelect"
                                :props="{ checkStrictly:true,expandTrigger:'hover'}"
                                :show-all-levels="false"
                                change-on-select
                                @change='handleChangeOperator'
                                v-model="safetyEditForm.operatorId">
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="充电站名称：" :label-width="formLabelWidth" prop="stationId">
                  <el-select placeholder="所属站" v-model="safetyEditForm.stationId" clearable  @change='handleChangeStation'>
                    <el-option v-for="item in stationsForSelect" :key="item.id"
                               v-bind:label="item.stationName"
                               v-bind:value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="场站详情" name="basicInformation">

              <el-col :span="12">
                <el-form-item label="场站编码：" :label-width="formLabelWidth" prop="stationCode">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.stationCode" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="场站名称：" :label-width="formLabelWidth" prop="stationName">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.stationName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="场站地址：" :label-width="formLabelWidth" prop="address">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.address" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="交付时间：" :label-width="formLabelWidth" prop="deliveryTime">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.deliveryTime" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客户联系人：" :label-width="formLabelWidth" prop="dutyPerson">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.dutyPerson" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式：" :label-width="formLabelWidth" prop="dutyPersonPhone">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.dutyPersonPhone" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="保修时间：" :label-width="formLabelWidth" prop="warrantyPeriod">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.warrantyPeriod" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="延保时间：" :label-width="formLabelWidth" prop="extendWarranty">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.extendWarranty" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售人：" :label-width="formLabelWidth" prop="salesman">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.salesman" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式：" :label-width="formLabelWidth" prop="salesmanPhone">
                  <el-input autocomplete="off" placeholder="请在场站管理填写!" v-model="safetyEditForm.salesmanPhone" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-collapse-item>
            <el-collapse-item title="管理信息" name="safetyInformation">
              <el-col :span="12">
                <el-form-item label="安全检查事项：" :label-width="formLabelWidth" prop="matter">
                  <el-input autocomplete="off" placeholder="安全检查事项" v-model="safetyEditForm.matter"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="审核状态：" :label-width="formLabelWidth" prop="auditStatus">
                  <el-select placeholder="审核状态" v-model="safetyEditForm.auditStatus">
                    <el-option v-for="item in auditStatusEnum" :key="item.value"
                               v-bind:label="item.message" v-bind:value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="22">
                <el-form-item label="要求：" :label-width="formLabelWidth" prop="claim">
                  <el-input  v-model="safetyEditForm.claim" autocomplete="off" placeholder="请填写安全检查事项要求！"
                            maxlength="200"
                            show-word-limit
                            type="textarea"
                            :rows="4"
                            clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22">
                <el-form-item label="建议：" :label-width="formLabelWidth" prop="advise">
                  <el-input v-model="safetyEditForm.advise" autocomplete="off" placeholder="请填写安全检查事项建议！"
                            maxlength="200"
                            show-word-limit
                            type="textarea"
                            :rows="4"
                            clearable></el-input>
                </el-form-item>
              </el-col>
            </el-collapse-item>
          </el-collapse>
        </el-form>
        <el-button size="mini" plain @click="closeSafetyEditForm">取 消</el-button>
        <el-button size="mini" plain type="primary" @click="submitSafety" :loading="editSubmitLoading">提交</el-button>
      </el-tab-pane>
      <el-tab-pane label="上传现场照片" name="newUploadSitePictures" v-if="checkPermission(['bee:res:station:uploadStationGuideImage'])">
        <el-form :model="newUploadSitePicturesForm" ref="newUploadSitePicturesForm" size="mini" style="height: 400px" class="uploadSitePicForm">
          <el-upload
            :action="uploadImage()"
            :on-preview="safetyHandlePictureCardPreview"
            :on-remove="stationHandleRemove"
            :before-upload="uploadSitePicFormBeforeUpload"
            :on-success="safetyUploadSuccess"
            :on-error="safetyUploadError"
            :on-exceed="safetyExceed"
            :limit="10"
            :file-list="newUploadSitePicturesList"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="stationDialogVisible">
            <img width="100%" :src="stationDialogImageUrl" alt="">
          </el-dialog>
        </el-form>
        <el-button size="mini" plain @click="closeSafetyEditForm">取 消</el-button>
        <el-button size="mini" plain type="primary" @click="submitSafety" :loading="editSubmitLoading">提交</el-button>
      </el-tab-pane>

    </el-tabs>
  </el-dialog>
</template>

<script>
  import stationApi from '../../api/stationApi'
  import {validateInput} from '../../../../common/validator'
  import sysConfig from '@/../config/sysConfig'
  import service from '@/../config/serviceList'
  import safetyApi from "../../api/safetyApi";
  import commonApi from "../../api/commonApi";
  export default {
    name: "customizeView",
    data(){
      return{
        viewName: 'editForm',
        bindingRateFormRules:{
          serviceBillingRulesIdTemp:[{required: true, message: '请选择费率', trigger: 'blur'}]
        },
        activeNames: ['stationInformation','basicInformation', 'safetyInformation'],
        formLabelWidth: '155px',
        inputVisible: false,
        inputValue: '',
        isUploadLogo:false,
        isUploadPicture:false,
        uploadAvatarFormDialogImageUrl: '',
        uploadAvatarFormDialogVisible: false,
        uploadSitePicFormDialogImageUrl: '',
        uploadSitePicFormDialogVisible: false,
        stationDialogVisible:false,
        stationDialogImageUrl:'',
        serviceBillingRulesIdTemp: '',
        createPileAndGunRules:{
        },
        loading:false
      }
    },
    props:{
      operatorForSelect: '',
      stationsForSelect: '',
      auditStatusEnum:'',
      safetyEditFormVisible:{
        type:Boolean,
        required: true
      },
      safetyEditForm: {},
      searchTabsAddForm: {
        searchTabs: []
      },
      editSubmitLoading:false,
      bindingRateForm: {},
      serviceBillingRulesSelect:{},
      uploadAvatarForm: {},
      uploadSitePicForm: {},
      stationUploadImageForm:{},
      newUploadSitePicturesForm:{},
      uploadAvatarFormFileList: {
        type:Array
      },
      uploadSitePicFormFileList: {
        type:Array
      },
      newUploadSitePicturesList:{
        type:Array
      },
      stationImageUrlList:{
        type:Array
      },
      createPileAndGunForm:{},
      protocolEnumData:'',
      pileModelEnumData:''
    },
    methods:{
      handleChangeStation(value) {
        if(this.safetyEditForm.stationId != null && this.safetyEditForm.stationId != ''){
          stationApi.getStationById(this.safetyEditForm.stationId).then((res) => {
            this.$nextTick(() => {
              this.safetyEditForm.stationCode = res.data.stationCode
              this.safetyEditForm.stationName =  res.data.stationName
              this.safetyEditForm.address =  res.data.address
              this.safetyEditForm.deliveryTime =  res.data.deliveryTime
              this.safetyEditForm.dutyPerson =  res.data.dutyPerson
              this.safetyEditForm.dutyPersonPhone =  res.data.dutyPersonPhone
              this.safetyEditForm.warrantyPeriod =  res.data.warrantyPeriod
              this.safetyEditForm.extendWarranty =  res.data.extendWarranty
              this.safetyEditForm.salesman =  res.data.salesman
              this.safetyEditForm.salesmanPhone =  res.data.salesmanPhone
              this.$forceUpdate()
            })
          })
        } else {
          this.safetyEditForm.stationCode = ''
          this.safetyEditForm.stationName = ''
          this.safetyEditForm.address = ''
          this.safetyEditForm.deliveryTime = ''
          this.safetyEditForm.dutyPerson = ''
          this.safetyEditForm.dutyPersonPhone = ''
          this.safetyEditForm.warrantyPeriod = ''
          this.safetyEditForm.extendWarranty = ''
          this.safetyEditForm.salesman = ''
          this.safetyEditForm.salesmanPhone = ''
        }
      },

      submitSafety(){
        this.safetyEditForm.pictures = this.stationImageUrlList;
        safetyApi.saveOrUpdateSafety(this.safetyEditForm).then((res) => {
          if (res.code === 0) {
            this.$message({
              message: res.message,
              type: 'success'
            });
            this.$emit("closeSafetyEditForm")
            this.$emit("submitSafetySearchForm")
          } else {
            this.$message.error(res.message)
          }
        })
      },

      editSubmit(){
        this.$emit('safetyEditSubmit',this.$refs.safetyEditForm)
      },

      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.safetyEditForm.operatorId = operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },

      closeSafetyEditForm(){
        let _this = this
        if(this.safetyEditForm.id == null || this.safetyEditForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeSafetyEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeSafetyEditForm')
        }
      },

      addDevice(){
        this.$router.push( '/resourceCenter/deviceManager')
      },

      /**
       * 图片上传撤回图片
       * @param file
       * @param fileList
       */
      stationHandleRemove(file, fileList) {
        this.stationImageUrlList.splice(this.stationImageUrlList.findIndex(item => item === file.name), 1);
      },

      safetyHandlePictureCardPreview(file) {
        this.stationDialogImageUrl = file.url;
        this.stationDialogVisible = true;
      },

      uploadImage() {
        return sysConfig.apiPre + service.ops + "/ops/upload/image_upload";
      },

      safetyUploadSuccess(response,file,fileList){
        if(response.code ===0){
          file.name = response.data;
          this.stationImageUrlList.push(response.data);
        }else{
          this.$message({
            type: 'error',
            message: "文件上传失败，请稍后重试"
          });
        }
      },

      safetyUploadError(err,file,fileList){
        console.log(err);
        this.$message({
          type: 'error',
          message: "文件上传失败，请稍后重试"
        });
      },

      safetyExceed(file,fileList){
        this.$message({
          type: 'info',
          message: "最多只能上传10张图片"
        });
      },

      // 添加标签
      handleClose(tag) {
        this.searchTabsAddForm.searchTabs.splice(this.searchTabsAddForm.searchTabs.indexOf(tag), 1)// 删除按钮
      },

      handleInputConfirm() {
        let inputValue = this.inputValue
        if (inputValue) {
          if (inputValue.length>4){
            this.$message.error("请不要输入超过8个字")
            return
          }
          if (this.searchTabsAddForm.searchTabs.length>10){
            this.$message.error("请不要添加超过10个标签")
            this.inputVisible = false
            this.inputValue = ''
            return
          }
          this.searchTabsAddForm.searchTabs.push(inputValue)// 添加按钮
        }
        this.inputVisible = false
        this.inputValue = ''
      },

      showInput() {
        this.inputVisible = true
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus()
        })
      },

      unbinding(){
        this.$emit("unbinding")
      },

      dobinding(){
        this.$emit("dobinding",this.$refs["bindingRateForm"])
      },

      compression(file){
        //只能上传图片格式
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');

        }
        if (!isJPG) {
          this.$message.error('上传头像图片只能是jpg/png格式!');
        }
        return isLt2M && isJPG;
      },

      uploadAvatarFormPictureCardPreview(file) {
        this.uploadAvatarFormDialogImageUrl = file.url;
        this.uploadAvatarFormDialogVisible = true;
      },

      uploadAvatarFormChange(file, fileList){
        this.isUploadLogo = true;
      },

      uploadAvatarFormRemove(file) {
        this.uploadAvatarForm.logo = "";
        this.isUploadLogo = true;
      },

      uploadAvatarFormBeforeUpload(file){
        if(!this.compression(file)){
          this.$emit('revertUploadAvatarFormFileList');
          this.uploadAvatarForm.logo =""
        }
      },

      uploadAvatarFormUpload(file) {
      },

      uploadAvatarFormRequest(file){
        this.uploadAvatarForm.logo = file.file
      },

      confirmUploadAvatarForm(){
        if(this.isUploadLogo===true){
          let param = new FormData();
          param.append("id",this.uploadAvatarForm.id);
          if(this.uploadAvatarForm.logo !== "" && this.uploadAvatarForm.logo !== null){
            param.append("logo",this.uploadAvatarForm.logo);
          }
          param.append("type","logo");
          stationApi.saveStationImg(param).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.$emit("closeView")
              this.$emit('submitStationSearchForm')
              this.$emit('revertUploadAvatarFormFileList')
            } else {
              this.$message.error(res.message)
            }
          })
        }else{
          this.$message({
            message: '未修改图片，无需提交',
            type: 'info'
          })
        }
      },

      uploadSitePicFormPictureCardPreview(file) {
        this.uploadSitePicFormDialogImageUrl = file.url;
        this.uploadSitePicFormDialogVisible = true;
      },

      uploadSitePicFormChange(file, fileList){
        this.isUploadPicture = true;
      },

      uploadSitePicFormRemove(file) {
        //this.uploadSitePicForm.picture.splice(file.url,1)
        this.uploadSitePicFormFileList=[];
        this.uploadSitePicForm.picture=[];
        this.isUploadPicture = true;
      },

      uploadSitePicFormBeforeUpload(file){
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M
      },

      uploadSitePicFormUpload(file) {
      },

      uploadSitePicFormRequest(file){
        this.uploadSitePicForm.picture = [...this.uploadSitePicForm.picture, file.file]
      },

      confirmUploadSitePicForm(){
        if(this.isUploadPicture===true){
          let param = new FormData();
          console.log(this.uploadSitePicForm)
          this.uploadSitePicForm.picture.forEach(function (file) {
            param.append('picture', file, file.name); // 因为要上传多个文件，所以需要遍历一下才行
            // 不要直接使用我们的文件数组进行上传，你会发现传给后台的是两个Object
          })
          param.append("id",this.uploadSitePicForm.id)
          param.append("type","stationImg");
          stationApi.saveStationImg(param).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.$emit("closeView");
              this.$emit('submitStationSearchForm')
              this.$emit('revertUploadSitePicFormFileList')
            } else {
              this.$message.error(res.message)
            }
          })
        }else{
          this.$message({
            message: '未修改图片，无需提交',
            type: 'info'
          })
        }
      },
    }
  }
</script>

<style scoped lang="less">
  /deep/ .detail_form, /deep/ .searchTabsAddForm, /deep/ .bindingRateForm, /deep/ .uploadAvatarForm, /deep/ .uploadSitePicForm
  {
    height: 550px;
    overflow: auto;

    .el-form-item__label {
      color: rgba(0, 0, 0, 0.47);
    }
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 10px;
    margin-right: 10px;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
    margin-top: 10px;
    margin-right: 10px;
  }

  .searchTabsAddForm,.uploadAvatarForm,.uploadSitePicForm,.bindingRateForm {
    text-align: left;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/safetyManager/add.vue